//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.REPORTS_SERVICE_URL) {
      throw new Error('REPORTS_SERVICE_URL must be set in environment');
    }

    return process.env.REPORTS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class TasksReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    tasksReportRequisition(request: TasksReportRequisitionRequest, reportPrintType: string): Promise<void> {
        let url_ = this.baseUrl + "/api/reports/tasks/requisition/{reportPrintType}";
        if (reportPrintType === undefined || reportPrintType === null)
            throw new Error("The parameter 'reportPrintType' must be defined.");
        url_ = url_.replace("{reportPrintType}", encodeURIComponent("" + reportPrintType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTasksReportRequisition(_response);
        });
    }

    protected processTasksReportRequisition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ResidentDataReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    residentDataReportRequisition(residentId: string, request: ResidentDataReportRequisitionRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/reports/residents/{residentId}/data/requisition";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResidentDataReportRequisition(_response);
        });
    }

    protected processResidentDataReportRequisition(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    getReports(): Promise<ReportResponse[]> {
        let url_ = this.baseUrl + "/api/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReports(_response);
        });
    }

    protected processGetReports(response: Response): Promise<ReportResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportResponse[]>(null as any);
    }
}

export class RecordsReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    recordReportRequisition(request: RecordReportRequisitionRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/reports/record/requisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecordReportRequisition(_response);
        });
    }

    protected processRecordReportRequisition(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PlansReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    plansReportRequisition(request: PlansReportRequisitionRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/reports/plans/requisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPlansReportRequisition(_response);
        });
    }

    protected processPlansReportRequisition(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class IncidentsReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    incidentsReportRequisition(request: IncidentsReportRequisitionRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/reports/incident/requisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIncidentsReportRequisition(_response);
        });
    }

    protected processIncidentsReportRequisition(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class HealthMeasurementsReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    healthMeasurementsReportRequisition(request: HealthMeasurementsReportRequisitionRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/reports/healthmeasurements/requisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthMeasurementsReportRequisition(_response);
        });
    }

    protected processHealthMeasurementsReportRequisition(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EmployeesReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-reports-dev.sekoia.one", baseUrl);
    }

    activeEmployeesReportRequisition(request: ActiveEmployeesReportRequisitionRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/reports/employees/ActiveEmployeesReportRequisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActiveEmployeesReportRequisition(_response);
        });
    }

    protected processActiveEmployeesReportRequisition(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class TasksReportRequisitionRequest implements ITasksReportRequisitionRequest {
    associatedPlanIds!: string[];
    associatedNexusVumSubGoalIds!: string[];
    residentIds!: string[];
    createdFrom!: CreatedFrom[];
    executingProfessionIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;
    isContactPersonRelated!: boolean;
    isHealthActReleated!: boolean;
    isMedicationRelated!: boolean;
    isResidentTask!: boolean;
    isEmployeeTask!: boolean;
    professionIds!: string[];
    standardTaskIds!: string[];
    requiresTwoWorkers!: boolean;
    states!: string[];
    includeHistory!: boolean;
    title!: string;
    timezone!: string;

    constructor(data?: ITasksReportRequisitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedPlanIds = [];
            this.associatedNexusVumSubGoalIds = [];
            this.residentIds = [];
            this.createdFrom = [];
            this.executingProfessionIds = [];
            this.professionIds = [];
            this.standardTaskIds = [];
            this.states = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["associatedPlanIds"])) {
                this.associatedPlanIds = [] as any;
                for (let item of _data["associatedPlanIds"])
                    this.associatedPlanIds!.push(item);
            }
            if (Array.isArray(_data["associatedNexusVumSubGoalIds"])) {
                this.associatedNexusVumSubGoalIds = [] as any;
                for (let item of _data["associatedNexusVumSubGoalIds"])
                    this.associatedNexusVumSubGoalIds!.push(item);
            }
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            if (Array.isArray(_data["createdFrom"])) {
                this.createdFrom = [] as any;
                for (let item of _data["createdFrom"])
                    this.createdFrom!.push(item);
            }
            if (Array.isArray(_data["executingProfessionIds"])) {
                this.executingProfessionIds = [] as any;
                for (let item of _data["executingProfessionIds"])
                    this.executingProfessionIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.isContactPersonRelated = _data["isContactPersonRelated"];
            this.isHealthActReleated = _data["isHealthActReleated"];
            this.isMedicationRelated = _data["isMedicationRelated"];
            this.isResidentTask = _data["isResidentTask"];
            this.isEmployeeTask = _data["isEmployeeTask"];
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            if (Array.isArray(_data["standardTaskIds"])) {
                this.standardTaskIds = [] as any;
                for (let item of _data["standardTaskIds"])
                    this.standardTaskIds!.push(item);
            }
            this.requiresTwoWorkers = _data["requiresTwoWorkers"];
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(item);
            }
            this.includeHistory = _data["includeHistory"];
            this.title = _data["title"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): TasksReportRequisitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TasksReportRequisitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.associatedPlanIds)) {
            data["associatedPlanIds"] = [];
            for (let item of this.associatedPlanIds)
                data["associatedPlanIds"].push(item);
        }
        if (Array.isArray(this.associatedNexusVumSubGoalIds)) {
            data["associatedNexusVumSubGoalIds"] = [];
            for (let item of this.associatedNexusVumSubGoalIds)
                data["associatedNexusVumSubGoalIds"].push(item);
        }
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        if (Array.isArray(this.createdFrom)) {
            data["createdFrom"] = [];
            for (let item of this.createdFrom)
                data["createdFrom"].push(item);
        }
        if (Array.isArray(this.executingProfessionIds)) {
            data["executingProfessionIds"] = [];
            for (let item of this.executingProfessionIds)
                data["executingProfessionIds"].push(item);
        }
        data["from"] = this.from ? this.from.format('YYYY-MM-DD') : <any>undefined;
        data["to"] = this.to ? this.to.format('YYYY-MM-DD') : <any>undefined;
        data["isContactPersonRelated"] = this.isContactPersonRelated;
        data["isHealthActReleated"] = this.isHealthActReleated;
        data["isMedicationRelated"] = this.isMedicationRelated;
        data["isResidentTask"] = this.isResidentTask;
        data["isEmployeeTask"] = this.isEmployeeTask;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        if (Array.isArray(this.standardTaskIds)) {
            data["standardTaskIds"] = [];
            for (let item of this.standardTaskIds)
                data["standardTaskIds"].push(item);
        }
        data["requiresTwoWorkers"] = this.requiresTwoWorkers;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item);
        }
        data["includeHistory"] = this.includeHistory;
        data["title"] = this.title;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface ITasksReportRequisitionRequest {
    associatedPlanIds: string[];
    associatedNexusVumSubGoalIds: string[];
    residentIds: string[];
    createdFrom: CreatedFrom[];
    executingProfessionIds: string[];
    from: moment.Moment;
    to: moment.Moment;
    isContactPersonRelated: boolean;
    isHealthActReleated: boolean;
    isMedicationRelated: boolean;
    isResidentTask: boolean;
    isEmployeeTask: boolean;
    professionIds: string[];
    standardTaskIds: string[];
    requiresTwoWorkers: boolean;
    states: string[];
    includeHistory: boolean;
    title: string;
    timezone: string;
}

export enum CreatedFrom {
    Screen = "Screen",
    Administration = "Administration",
}

export class ResidentDataReportRequisitionRequest implements IResidentDataReportRequisitionRequest {
    title!: string;
    residentDataCategories!: ResidentDataCategory[];
    includeHistory!: boolean;
    timezone!: string;
    requisitionReason!: string;

    constructor(data?: IResidentDataReportRequisitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentDataCategories = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["residentDataCategories"])) {
                this.residentDataCategories = [] as any;
                for (let item of _data["residentDataCategories"])
                    this.residentDataCategories!.push(item);
            }
            this.includeHistory = _data["includeHistory"];
            this.timezone = _data["timezone"];
            this.requisitionReason = _data["requisitionReason"];
        }
    }

    static fromJS(data: any): ResidentDataReportRequisitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentDataReportRequisitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.residentDataCategories)) {
            data["residentDataCategories"] = [];
            for (let item of this.residentDataCategories)
                data["residentDataCategories"].push(item);
        }
        data["includeHistory"] = this.includeHistory;
        data["timezone"] = this.timezone;
        data["requisitionReason"] = this.requisitionReason;
        return data;
    }
}

export interface IResidentDataReportRequisitionRequest {
    title: string;
    residentDataCategories: ResidentDataCategory[];
    includeHistory: boolean;
    timezone: string;
    requisitionReason: string;
}

export enum ResidentDataCategory {
    KeyData = "KeyData",
    HealthInfo = "HealthInfo",
    Anamnesis = "Anamnesis",
    InternalContacts = "InternalContacts",
    Consent = "Consent",
}

export class ReportResponse implements IReportResponse {
    id!: string;
    type!: ReportType;
    printType!: ReportPrintType;
    customerId!: string;
    employeeId!: string;
    status!: ReportStatus;
    timeOfRequisition!: moment.Moment;
    title!: string;
    url?: string | undefined;

    constructor(data?: IReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.printType = _data["printType"];
            this.customerId = _data["customerId"];
            this.employeeId = _data["employeeId"];
            this.status = _data["status"];
            this.timeOfRequisition = _data["timeOfRequisition"] ? moment(_data["timeOfRequisition"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["printType"] = this.printType;
        data["customerId"] = this.customerId;
        data["employeeId"] = this.employeeId;
        data["status"] = this.status;
        data["timeOfRequisition"] = this.timeOfRequisition ? this.timeOfRequisition.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["url"] = this.url;
        return data;
    }
}

export interface IReportResponse {
    id: string;
    type: ReportType;
    printType: ReportPrintType;
    customerId: string;
    employeeId: string;
    status: ReportStatus;
    timeOfRequisition: moment.Moment;
    title: string;
    url?: string | undefined;
}

export enum ReportType {
    None = "None",
    Records = "Records",
    Plans = "Plans",
    Incidents = "Incidents",
    ResidentData = "ResidentData",
    HealthMeasurements = "HealthMeasurements",
    Tasks = "Tasks",
    ActiveEmployeeList = "ActiveEmployeeList",
}

export enum ReportPrintType {
    Pdf = "Pdf",
    Xlsx = "Xlsx",
}

export enum ReportStatus {
    None = "None",
    Ordered = "Ordered",
    InProgress = "InProgress",
    Ready = "Ready",
    Error = "Error",
}

export class RecordReportRequisitionRequest implements IRecordReportRequisitionRequest {
    title!: string;
    filter!: RecordFilterRequest;
    timezone!: string;
    requisitionReason!: string;

    constructor(data?: IRecordReportRequisitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filter = new RecordFilterRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.filter = _data["filter"] ? RecordFilterRequest.fromJS(_data["filter"]) : new RecordFilterRequest();
            this.timezone = _data["timezone"];
            this.requisitionReason = _data["requisitionReason"];
        }
    }

    static fromJS(data: any): RecordReportRequisitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecordReportRequisitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["timezone"] = this.timezone;
        data["requisitionReason"] = this.requisitionReason;
        return data;
    }
}

export interface IRecordReportRequisitionRequest {
    title: string;
    filter: RecordFilterRequest;
    timezone: string;
    requisitionReason: string;
}

export class RecordFilterRequest implements IRecordFilterRequest {
    residentId!: string;
    searchText?: string | undefined;
    planIds?: string[] | undefined;
    accessControlTagIds?: string[] | undefined;
    formIds?: string[] | undefined;
    incidentTemplateIds?: string[] | undefined;
    healthMeasurementTypes?: string[] | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    recordSearchTypes?: RecordSearchType[] | undefined;
    categories?: string[][] | undefined;

    constructor(data?: IRecordFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["planIds"])) {
                this.planIds = [] as any;
                for (let item of _data["planIds"])
                    this.planIds!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            if (Array.isArray(_data["incidentTemplateIds"])) {
                this.incidentTemplateIds = [] as any;
                for (let item of _data["incidentTemplateIds"])
                    this.incidentTemplateIds!.push(item);
            }
            if (Array.isArray(_data["healthMeasurementTypes"])) {
                this.healthMeasurementTypes = [] as any;
                for (let item of _data["healthMeasurementTypes"])
                    this.healthMeasurementTypes!.push(item);
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recordSearchTypes"])) {
                this.recordSearchTypes = [] as any;
                for (let item of _data["recordSearchTypes"])
                    this.recordSearchTypes!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): RecordFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecordFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.planIds)) {
            data["planIds"] = [];
            for (let item of this.planIds)
                data["planIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        if (Array.isArray(this.incidentTemplateIds)) {
            data["incidentTemplateIds"] = [];
            for (let item of this.incidentTemplateIds)
                data["incidentTemplateIds"].push(item);
        }
        if (Array.isArray(this.healthMeasurementTypes)) {
            data["healthMeasurementTypes"] = [];
            for (let item of this.healthMeasurementTypes)
                data["healthMeasurementTypes"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.recordSearchTypes)) {
            data["recordSearchTypes"] = [];
            for (let item of this.recordSearchTypes)
                data["recordSearchTypes"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }
}

export interface IRecordFilterRequest {
    residentId: string;
    searchText?: string | undefined;
    planIds?: string[] | undefined;
    accessControlTagIds?: string[] | undefined;
    formIds?: string[] | undefined;
    incidentTemplateIds?: string[] | undefined;
    healthMeasurementTypes?: string[] | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    recordSearchTypes?: RecordSearchType[] | undefined;
    categories?: string[][] | undefined;
}

export enum RecordSearchType {
    Tasks = "Tasks",
    Plans = "Plans",
    Forms = "Forms",
    HealthMeasurements = "HealthMeasurements",
    ResidentProfile = "ResidentProfile",
    Entries = "Entries",
    Incidents = "Incidents",
    Inventory = "Inventory",
}

export class PlansReportRequisitionRequest implements IPlansReportRequisitionRequest {
    title!: string;
    residentId!: string;
    planIds!: string[];
    includeHistory!: boolean;
    includeRecordEntries!: boolean;
    timezone!: string;

    constructor(data?: IPlansReportRequisitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.planIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.residentId = _data["residentId"];
            if (Array.isArray(_data["planIds"])) {
                this.planIds = [] as any;
                for (let item of _data["planIds"])
                    this.planIds!.push(item);
            }
            this.includeHistory = _data["includeHistory"];
            this.includeRecordEntries = _data["includeRecordEntries"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): PlansReportRequisitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlansReportRequisitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["residentId"] = this.residentId;
        if (Array.isArray(this.planIds)) {
            data["planIds"] = [];
            for (let item of this.planIds)
                data["planIds"].push(item);
        }
        data["includeHistory"] = this.includeHistory;
        data["includeRecordEntries"] = this.includeRecordEntries;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IPlansReportRequisitionRequest {
    title: string;
    residentId: string;
    planIds: string[];
    includeHistory: boolean;
    includeRecordEntries: boolean;
    timezone: string;
}

export class IncidentsReportRequisitionRequest implements IIncidentsReportRequisitionRequest {
    title!: string;
    incidentId!: number;
    timezone!: string;

    constructor(data?: IIncidentsReportRequisitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.incidentId = _data["incidentId"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): IncidentsReportRequisitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentsReportRequisitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["incidentId"] = this.incidentId;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IIncidentsReportRequisitionRequest {
    title: string;
    incidentId: number;
    timezone: string;
}

export class HealthMeasurementsReportRequisitionRequest implements IHealthMeasurementsReportRequisitionRequest {
    residentId!: string;
    title!: string;
    healthMeasurementTypes!: HealthMeasurementType[];
    timezone!: string;
    requisitionReason!: string;
    from!: moment.Moment;
    to!: moment.Moment;
    includeDeleted!: boolean;

    constructor(data?: IHealthMeasurementsReportRequisitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.healthMeasurementTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.title = _data["title"];
            if (Array.isArray(_data["healthMeasurementTypes"])) {
                this.healthMeasurementTypes = [] as any;
                for (let item of _data["healthMeasurementTypes"])
                    this.healthMeasurementTypes!.push(item);
            }
            this.timezone = _data["timezone"];
            this.requisitionReason = _data["requisitionReason"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.includeDeleted = _data["includeDeleted"];
        }
    }

    static fromJS(data: any): HealthMeasurementsReportRequisitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementsReportRequisitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["title"] = this.title;
        if (Array.isArray(this.healthMeasurementTypes)) {
            data["healthMeasurementTypes"] = [];
            for (let item of this.healthMeasurementTypes)
                data["healthMeasurementTypes"].push(item);
        }
        data["timezone"] = this.timezone;
        data["requisitionReason"] = this.requisitionReason;
        data["from"] = this.from ? this.from.format('YYYY-MM-DD') : <any>undefined;
        data["to"] = this.to ? this.to.format('YYYY-MM-DD') : <any>undefined;
        data["includeDeleted"] = this.includeDeleted;
        return data;
    }
}

export interface IHealthMeasurementsReportRequisitionRequest {
    residentId: string;
    title: string;
    healthMeasurementTypes: HealthMeasurementType[];
    timezone: string;
    requisitionReason: string;
    from: moment.Moment;
    to: moment.Moment;
    includeDeleted: boolean;
}

export enum HealthMeasurementType {
    BloodGlucose = "BloodGlucose",
    BloodPressure = "BloodPressure",
    RespiratoryRate = "RespiratoryRate",
    OxygenSaturation = "OxygenSaturation",
    BodyTemperature = "BodyTemperature",
    HeartRate = "HeartRate",
    BodyWeight = "BodyWeight",
    Height = "Height",
}

export class ActiveEmployeesReportRequisitionRequest implements IActiveEmployeesReportRequisitionRequest {
    timezone!: string;

    constructor(data?: IActiveEmployeesReportRequisitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): ActiveEmployeesReportRequisitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveEmployeesReportRequisitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IActiveEmployeesReportRequisitionRequest {
    timezone: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}